import { useRouteMatch } from 'react-router-dom';

/**
 * Get the parameters defined in the current route,
 * such as the :id in "/vehicles/:id".
 *
 * Unlike `useRouteMatch`, this function returns
 * only the parameters. It also decodes them out of
 * URL format.
 *
 * As always, some keys you expect may be undefined.
 */
function useRouteMatchParams(): Record<string, string> {
  const match = useRouteMatch<Record<string, string>>();
  const result = match?.params || {};
  return Object.fromEntries(
    Object.entries(result).map(([key, value]) => {
      return [key, decodeURIComponent(value)];
    }),
  );
}

export default useRouteMatchParams;
